/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const AudioBookPlayer = ({
  openAudio,
  title = '',
  audiobooks,
}: {
  title?: string;
  openAudio: any;
  audiobooks: any[];
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { colors } = useTheme();

  const sortedAudiobooks = audiobooks.sort((a, b) => a.position - b.position).filter((audiobook) => audiobook.file);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, sortedAudiobooks.length - 1));
  };

  useState(() => {
    if (openAudio.isOpen) {
      setCurrentIndex(0);
    }
  }, [openAudio.isOpen]);

  return (
    <Modal isCentered size={'sm'} isOpen={openAudio.isOpen} onClose={openAudio.onClose}>
      <ModalOverlay backdropFilter={'blur(10px)'} />
      <ModalContent borderRadius={'20px'}>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody padding="25px">
          <Box>
            {audiobooks.length === 0 ? (
              <Heading
                as="h3"
                marginBottom={'20px'}
                textAlign={'center'}
                width={'100%'}
                size="md"
                color={colors.primaryColor}
              >
                Nenhum audiobook disponível
              </Heading>
            ) : (
              <Heading as="h3" size="md" color={colors.primaryColor}>
                {sortedAudiobooks[currentIndex]?.title}
              </Heading>
            )}
            <AudioPlayer
              autoPlay
              key={currentIndex}
              src={sortedAudiobooks[currentIndex]?.file}
              showJumpControls={true}
              showSkipControls={true}
              showFilledVolume={true}
              onEnded={() => {
                if (currentIndex < sortedAudiobooks.length - 1) {
                  setCurrentIndex(currentIndex + 1);
                } else {
                  setCurrentIndex(0);
                }
              }}
            />
            <HStack spacing={4} justifyContent="center" marginTop="2vh">
              <Button onClick={handlePrev} disabled={currentIndex === 0}>
                <FaChevronLeft />
              </Button>
              <Heading as="h4" size="md" color={colors.primaryColor}>
                {'Parte ' + (Number(currentIndex) + 1)}
              </Heading>
              <Button onClick={handleNext} disabled={currentIndex === sortedAudiobooks.length - 1}>
                <FaChevronRight />
              </Button>
            </HStack>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AudioBookPlayer;
